import { fetchFactory } from 'isotope-client'
import { RequestUpdateStockModel } from './stockModel'

export const updateStock = (values: RequestUpdateStockModel) => fetchFactory(`/${values.centerType}/stock`, {
    method: 'PUT',
    body: JSON.stringify(values)
})
